import React from "react";
import { Link } from "react-router-dom";

import Seo from "../seo/Seo";
import PageHeader from "../components/PageHeader";
import { GAMES_BY_TIME } from "../data/games";
import { useNowIST } from "../lib/useResults";

/**
 * A soft-404 (a "not found" message served as 200 with no noindex) gets the
 * URL indexed as thin content, so this page marks itself noindex and routes
 * the visitor somewhere useful.
 */
const NotFound = () => {
  const nowIST = useNowIST();

  return (
    <>
      <Seo
        path="/404"
        title="Page Not Found | Bagad Satta Company"
        description="This page does not exist. Find live satta results and monthly charts on the Bagad Satta Company home page."
        noindex
      />

      <div className="page-banner">
        <div className="container page-padding">
          <PageHeader
            h1="Page Not Found"
            intro="That page does not exist — but every result and chart is one tap away."
            nowIST={nowIST}
          />

          <section className="card text-content">
            <h2>Try One of These</h2>
            <ul className="related-links">
              <li>
                <Link to="/">Live satta result today</Link>
              </li>
              <li>
                <Link to="/satta-chart">Full monthly satta chart</Link>
              </li>
              <li>
                <Link to="/faq">Frequently asked questions</Link>
              </li>
            </ul>

            <h2>Result Pages</h2>
            <ul className="related-links">
              {GAMES_BY_TIME.map((game) => (
                <li key={game.key}>
                  <Link to={`/${game.slug}`}>
                    {game.name} Satta Result — {game.timeLabel}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </>
  );
};

export default NotFound;
